<fgbcl-featured-rewards [title]="'featured.title' | translate" [showAllPath]="'/rewards/marketplace'"></fgbcl-featured-rewards>
